export default __webpack_public_path__ + "static/media/IconsNoconnectionWhite.2fb65487.svg";